('');

import { fetchOnBoardingStep5, onCompletedOnBoarding } from '@/services/on-boarding/onboarding.service';
import { Step5 } from '../../../graphql/generated/graphql';
import { getAuthentication } from '../../../hooks/useAuthentication';
import { useOnBoarding } from './useOnBoarding';

export function useOnBoardingStep5() {
  const { response, handleNext, page } = useOnBoarding<Step5>({
    fetchFn: fetchOnBoardingStep5,
  });

  const onClickOnBoardingCompleted = async () => {
    const { user } = getAuthentication();
    if (!user) return;
    await onCompletedOnBoarding(user.id);
    handleNext();
  };

  return {
    response,
    onClickOnBoardingCompleted,
    page,
  };
}
